import { render, staticRenderFns } from "./FieldsBlock.vue?vue&type=template&id=06fb8d18&scoped=true"
import script from "./FieldsBlock.vue?vue&type=script&lang=js"
export * from "./FieldsBlock.vue?vue&type=script&lang=js"
import style0 from "./FieldsBlock.vue?vue&type=style&index=0&id=06fb8d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb8d18",
  null
  
)

export default component.exports